<template>
	<BaseLoading v-if="isLoading" />
	<div v-else>
		<BannerCreateAndFilter
			ref="create-and-filter"
			:create-link="createLink"
			:widget-options="widgetOptions"
			:found="meta.total"
			type-found-text="Content Block"
			:content-block-type="contentBlockType"
			:create-button-text="$t('global.general.create', { type: 'content block' })"
			:placeholder-text="$t('global.general.searchPlaceholder', { type: 'content block' })"
		/>

		<CRow>
			<CCol>
				<BaseTable
					:pagination="{
						pages: meta.lastPage,
						activePage: meta.currentPage,
					}"
					:fields="tableFields"
					:items="dataTable"
					clickable-rows
					:link-to="editLink"
					vertical-align="top"
					class="table-custom table-custom-link"
					@onPaginationClick="handlePageChange"
				>
					<template #no-items-view>
						<div class="empty-table-element">
							<p class="subtitle">
								{{
									$t('global.searchNotFound', {
										field: 'content block',
									})
								}}
							</p>
						</div>
					</template>
					<template #name="{item}">
						<div class="d-flex align-items-center content-block-name">
							<img v-if="hasImage" class="thumbnail-40 mr-3" :src="item.thumbnail">
							<strong>{{ item.name }}</strong>
						</div>
					</template>
					<template #period="{item}">
						<CBadge class="badge-status" :color="BANNER_PERIOD_COLOR[item.value]">
							{{ item.name }}
						</CBadge>
					</template>
					<template #widgets="{item}">
						<ul v-if="item.length" class="widget-list">
							<li v-for="(widget, key) in item" :key="key">
								{{ widget }}
							</li>
						</ul>
						<template v-else>
							-
						</template>
					</template>
					<template #status="{item}">
						<CBadge class="badge-status" :color="item.value">
							{{ item.name }}
						</CBadge>
					</template>
				</BaseTable>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import BannerCreateAndFilter from './BannerCreateAndFilter.vue';

import { CONTENT_BLOCK_TYPE, CONTENT_BLOCK_TABLE_FIELDS } from '../enums/contentBlocks';
import { BANNER_PERIOD_COLOR } from '../enums/banners';

export default {
	name: 'ContentBlockList',

	components: {
		BannerCreateAndFilter,
	},

	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		data: {
			type: Array,
			default: () => [],
		},
		meta: {
			type: Object,
			default: () => ({}),
		},
		createLink: {
			type: String,
			default: '',
		},
		editLink: {
			type: String,
			default: '',
		},
		widgetOptions: {
			type: Array,
			default: () => [],
		},

		// CONTENT_BLOCK_TYPE
		contentBlockType: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			BANNER_PERIOD_COLOR,
			CONTENT_BLOCK_TABLE_FIELDS,
			CONTENT_BLOCK_TYPE,
		};
	},
	computed: {
		dataTable() {
			return this.data.map((data) => ({
				...data,
				name: { name: data.name, thumbnail: data.thumbnail },
			}));
		},

		tableFields() {
			return CONTENT_BLOCK_TABLE_FIELDS;
		},

		hasImage() {
			if (!this.contentBlockType) {
				return false;
			}

			const hasImageList = [
				CONTENT_BLOCK_TYPE.HIGHLIGHT,
			];
			return hasImageList.includes(this.contentBlockType);
		},
	},
	methods: {
		handlePageChange(page) {
			this.$refs['create-and-filter'].handlePageChange(page);
		},
	},
};
</script>

<style lang="scss" scoped>
	.widget-list {
		list-style: none;
		padding: 0;

		li {
			@include typo-body-2;
		}
	}

	::v-deep .table-custom {
		.content-block-name {
			max-width: rem(350);
		}
	}
</style>
